<template>
  <CRow>
    <CCol md="12">
      <div class="text-center">
        <div class="category-title">Depositos en Monedero</div>
      </div>
      <br />
      <div class="text-center">
        <img :src="item.image_filename ? item.image_filename : 'no-image.jpg'" class="award-image" />
      </div>
      <br />
      <div class="text-center award-name">{{ item.name }}</div>
      <br />
      <div class="text-center award-description">{{ item.description }}</div>

      <div class="range-summary-card">
        <div class="summary-line"><strong>Tus puntos:</strong> {{ formatNumber(availablePoints) }}</div>
        <div class="summary-line"><strong>Minimo:</strong> {{ formatNumber(rangeStart) }}</div>
        <div class="summary-line"><strong>Maximo:</strong> {{ formatNumber(rangeEnd) }}</div>
      </div>

      <div class="text-center selected-amount">
        Monto a canjear: <strong>{{ formatNumber(selectedValue) }} puntos</strong>
      </div>

      <div class="range-shell" :class="{ 'range-disabled': !canRedeemMinimum }">
        <div class="range-labels">
          <span>{{ formatNumber(rangeStart) }}</span>
          <span>{{ formatNumber(maxSelectable) }}</span>
        </div>

        <input
          type="range"
          class="range-input"
          :min="rangeStart"
          :max="maxSelectable"
          :step="rangeStep"
          :list="rangeListId"
          v-model.number="selectedValue"
          :disabled="!canRedeemMinimum"
        />

        <datalist :id="rangeListId">
          <option v-for="value in selectableValues" :key="`tick-${value}`" :value="value" />
        </datalist>
      </div>

      <div v-if="!canRedeemMinimum" class="text-danger text-center range-warning">
        Necesitas al menos {{ formatNumber(rangeStart) }} puntos para canjear este premio.
      </div>

      <br />
      <div class="text-justify">
        Al confirmar el canje se descontaran
        <span class="font-weight-bold">{{ formatNumber(selectedValue) }} puntos</span>
        de tu cuenta para generar la solicitud del deposito.
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'AwardBuyModalWalletRangeContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    availablePoints: {
      type: Number,
      default: 0
    },
    selectedPoints: {
      type: Number,
      default: 0
    }
  },
  computed: {
    rangeStart () {
      return Math.max(0, Number(this.item.range_start || 0))
    },
    rangeEnd () {
      return Math.max(0, Number(this.item.range_end || 0))
    },
    rangeStep () {
      const step = Math.max(1, Number(this.item.range_step || 1))
      return step
    },
    rangeListId () {
      return `wallet-range-${this.item.id || 'new'}`
    },
    maxSelectable () {
      const availableLimit = Math.max(0, Number(this.availablePoints || 0))
      const rawMax = Math.min(this.rangeEnd, availableLimit)

      if (rawMax < this.rangeStart) {
        return this.rangeStart
      }

      const steps = Math.floor((rawMax - this.rangeStart) / this.rangeStep)
      return this.rangeStart + steps * this.rangeStep
    },
    canRedeemMinimum () {
      return this.availablePoints >= this.rangeStart
        && this.rangeStart > 0
        && this.maxSelectable >= this.rangeStart
    },
    selectableValues () {
      const values = []
      if (!this.canRedeemMinimum) {
        return values
      }

      for (let value = this.rangeStart; value <= this.maxSelectable; value += this.rangeStep) {
        values.push(value)
      }

      return values
    },
    selectedValue: {
      get () {
        return this.normalizeValue(this.selectedPoints)
      },
      set (value) {
        this.$emit('update:selected-points', this.normalizeValue(value))
      }
    }
  },
  methods: {
    normalizeValue (value) {
      let normalized = Number(value || 0)

      if (!this.canRedeemMinimum) {
        return 0
      }

      if (normalized < this.rangeStart) {
        normalized = this.rangeStart
      }

      if (normalized > this.maxSelectable) {
        normalized = this.maxSelectable
      }

      const stepCount = Math.round((normalized - this.rangeStart) / this.rangeStep)
      normalized = this.rangeStart + (stepCount * this.rangeStep)

      if (normalized > this.maxSelectable) {
        normalized = this.maxSelectable
      }

      return normalized
    },
    formatNumber (value) {
      const number = Number(value || 0)
      return number.toLocaleString('es-MX')
    }
  }
}
</script>

<style scoped>
.category-title {
  font-size: 14px;
  font-weight: bold;
  color: #2288ee;
}

.award-image {
  height: 120px;
}

.award-name {
  font-size: 14px;
  font-weight: bold;
}

.award-description {
  font-size: 12px;
  font-style: italic;
}

.range-summary-card {
  margin-top: 14px;
  border: 1px solid #d6dee8;
  border-radius: 8px;
  padding: 10px 12px;
  background: #f8fafc;
}

.summary-line {
  font-size: 12px;
}

.selected-amount {
  margin-top: 14px;
  font-size: 16px;
  color: #1f4f82;
}

.range-shell {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #d6dee8;
  border-radius: 8px;
  background: #ffffff;
}

.range-disabled {
  opacity: 0.65;
}

.range-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #5b6470;
  margin-bottom: 6px;
}

.range-input {
  width: 100%;
}

.steps-container {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.step-button {
  border: 1px solid #cfd8e3;
  background: #f8fafc;
  color: #2c3e50;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 12px;
}

.step-active {
  background: #2eb85c;
  border-color: #2eb85c;
  color: #ffffff;
}

.range-warning {
  margin-top: 10px;
  font-size: 12px;
}
</style>
